import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';


// customizable method: use your own `Plotly` object
import createPlotlyComponent from 'react-plotly.js/factory';
//const Plot = createPlotlyComponent(Plotly);

import backend_url from "../../../../routes/API_URL";

import swal from 'sweetalert';


const API_URL = backend_url['api_url'];


var Plotly = require('plotly.js')
//var createPlotlyComponent = require('plotlyjs-react')
var Plot = createPlotlyComponent(Plotly)



class ProgressGraph extends Component {
	constructor(props) {
		super(props);
		//const visit_id=this.props.visit_id;
		const year_id = props.year_id;

		const date_object1 = new Date();
		const current_year1 = date_object1.getFullYear();

		this.state = {
			Graph_Data: [],
			year: year_id,
			current_year1: current_year1,
			bearer_auth: window.sessionStorage.getItem('token'),
		};

		this.abortController = new AbortController();

	}

	/* componentDidMount () {
	   
	   Promise.all([axios.get(API_URL + `/progress_report/${this.state.current_year1}`)]).then(
	   //Promise.all([axios.get(API_URL + `/progress_report/`)]).then(
	   ([g_data])=>{
		   this.setState({
			   Graph_Data:g_data.data,
		   })
	   }
	   )
	} */

	componentDidMount() {
		axios.get(API_URL + `/dashboard/charts/progress-graph`, {
			headers: { "Authorization": `Bearer ${this.state.bearer_auth}` },
			signal: this.abortController.signal
		})
			.then(response => {
				// console.log('Progress Graph Response:', response);
				if (response.data.success) {
					this.setState({
						Graph_Data: response.data.data,
					});
				} else {
					// Fallback
					this.fallbackToOldEndpoint();
				}
			})
			.catch(error => {
				console.error('Progress Graph Error:', error);
				this.fallbackToOldEndpoint();
			})
	}

	fallbackToOldEndpoint = () => {
		axios.get(API_URL + `/progress_report`, {
			headers: { "Authorization": `Bearer ${this.state.bearer_auth}` },
			signal: this.abortController.signal
		})
			.then(response => {
				this.setState({
					Graph_Data: response.data,
				});
			})
			.catch(error => {
				console.error('Fallback failed:', error);
				this.setState({ Graph_Data: [] });
			})
	}

	componentWillUnmount() {
		this.abortController.abort();
	}

	render() {
    const { Graph_Data } = this.state;

    const date_object = new Date();
    const current_year = date_object.getFullYear();

    // Step 1: Aggregate - compute average ACHIEVEMENT per NES per DATE
    const aggregated = {}; // { DATE: { NES: { sum, count } } }

    for (let i = 0; i < Graph_Data.length; i++) {
        const { DATE, NES, ACHIEVEMENT } = Graph_Data[i];
        const achievementVal = parseFloat(ACHIEVEMENT);

        if (isNaN(achievementVal)) continue;
        if (parseInt(current_year - DATE) >= 10 || parseInt(current_year - DATE) < 0) continue;

        if (!aggregated[DATE]) aggregated[DATE] = {};
        if (!aggregated[DATE][NES]) aggregated[DATE][NES] = { sum: 0, count: 0 };

        aggregated[DATE][NES].sum += achievementVal;
        aggregated[DATE][NES].count += 1;
    }

    // Step 2: Get sorted unique NES labels for x-axis
    const nesSet = new Set();
    Object.values(aggregated).forEach(nesMap => {
        Object.keys(nesMap).forEach(nes => nesSet.add(nes));
    });
    const nes_label = [...nesSet].sort((a, b) => parseInt(a) - parseInt(b));

    // Step 3: Build one bar trace per year
    const data = Object.keys(aggregated)
        .sort()
        .map(year => {
            const nesMap = aggregated[year];
            const x = [];
            const y = [];

            nes_label.forEach(nes => {
                if (nesMap[nes]) {
                    x.push(`NES ${nes}`);
                    const avg = nesMap[nes].sum / nesMap[nes].count;
                    y.push(parseFloat(avg.toFixed(2)));
                }
            });

            return {
                type: 'bar',
                mode: 'group',
                name: year,
                x: x,
                y: y,
                text: y.map(v => v.toFixed(2)),
                textposition: 'auto',
            };
        });

    const layout = {
        title: "NATIONAL PROGRESS OVERVIEW",
        barmode: 'group',
        autosize: true,
        xaxis: {
            type: 'category',
            title: 'National Education Standards',
            categoryorder: 'array',
            categoryarray: nes_label.map(n => `NES ${n}`)
        },
        yaxis: {
            title: 'Average NES Level',
            range: [0, 5]
        },
    };

    const useResizeHandler = true;
    const style = { width: "100%", height: "100%" };

    return (
        <React.Fragment>
            <Plot
                data={data}
                layout={layout}
                useResizeHandler={useResizeHandler}
                style={style}
                config={{ responsive: true, displaylogo: false }}
            />
        </React.Fragment>
    );
}
}

export default ProgressGraph;